module.exports = __webpack_public_path__ + "img/Coupes.dab3f2b4.svg";